import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
        font-size: 35px;
        margin-bottom: 10px;
    }

    div{
        p:first-child {
            display: flex;            
        }
    }
`;
